<!-- Skeleton Table (Shown when isLoading is true) -->
@if (!usingAutoLoad() && isLoading()) {
  <table mat-table [dataSource]="skeletonRows" class="mat-elevation-z8">
    @for (column of displayedColumns(); track column; let i = $index) {
      <ng-container [matColumnDef]="column">
        <!-- <th mat-header-cell *matHeaderCellDef>
      <div class="skeleton-placeholder-text"></div>
    </th> -->
        <th
          mat-header-cell
          *matHeaderCellDef
          class="tableHeaderCell"
          [style.min-width]="getColumnMinWidth(i)"
        >
          {{ headers()[i] }}
        </th>
        <td mat-cell *matCellDef>
          <div class="skeleton-placeholder-text"></div>
        </td>
      </ng-container>
    }
    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: columnsToDisplay"
      class="skeleton-row"
    ></tr>
  </table>
}
@if ((!usingAutoLoad() && !isLoading()) || usingAutoLoad()) {
  <!-- Real Data Table (Shown when isLoading is false) -->
  <!-- Use dataSource for sortable tables, data() for non-sortable -->
  @if (enableSorting()) {
    <table
      mat-table
      [dataSource]="dataSource"
      matSort
      (matSortChange)="onSortChange($event)"
      class="mat-elevation-z8"
    >
      @for (column of displayedColumns(); track column; let i = $index) {
        <ng-container [matColumnDef]="column">
          <!-- Header cell with sorting -->
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="tableHeaderCell"
            [style.min-width]="getColumnMinWidth(i)"
          >
            {{ headers()[i] }}
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            [style]="customStyle()"
            [ngClass]="
              element &&
              column == customStyleColumn() &&
              element[customStylepProp()]
                ? element[customStylepProp()]
                : ''
            "
            (click)="cellClick(element, column)"
          >
            @if (column != customBoolColumn()) {
              <span [class.link]="columnsLink().indexOf(column) > -1">{{
                element[column]
              }}</span>
            }
            @if (column == customBoolColumn() && element[customBoolColumn()]) {
              <mat-icon class="success-light">check_small</mat-icon>
            }

            @if (
              column == "button" &&
              (!element.hasOwnProperty("showButton") ||
                element["showButton"] == true)
            ) {
              <button mat-button color="primary" (click)="buttonClick(element)">
                <mat-icon>read_more</mat-icon>
              </button>
            }
          </td>
        </ng-container>
      }
      <!-- Disclaimer column -->
      <ng-container matColumnDef="disclaimer">
        <td
          mat-footer-cell
          *matFooterCellDef
          colspan="2"
          style="font-size: 12px; font-style: italic; color: gray"
        >
          {{ footer() }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: columnsToDisplay"
        (click)="rowClick(row)"
        [class.selected]="row === selectedRow"
      ></tr>

      <tr
        mat-footer-row
        *matFooterRowDef="['disclaimer']"
        style="height: 18px"
      ></tr>
    </table>
  } @else {
    <!-- Non-sortable table (original implementation) -->
    <table mat-table [dataSource]="data()" class="mat-elevation-z8">
      @for (column of displayedColumns(); track column; let i = $index) {
        <ng-container [matColumnDef]="column">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="tableHeaderCell"
            [style.min-width]="getColumnMinWidth(i)"
          >
            {{ headers()[i] }}
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            [style]="customStyle()"
            [ngClass]="
              element &&
              column == customStyleColumn() &&
              element[customStylepProp()]
                ? element[customStylepProp()]
                : ''
            "
            (click)="cellClick(element, column)"
          >
            @if (column != customBoolColumn()) {
              <span [class.link]="columnsLink().indexOf(column) > -1">{{
                element[column]
              }}</span>
            }
            @if (column == customBoolColumn() && element[customBoolColumn()]) {
              <mat-icon class="success-light">check_small</mat-icon>
            }

            @if (
              column == "button" &&
              (!element.hasOwnProperty("showButton") ||
                element["showButton"] == true)
            ) {
              <button mat-button color="primary" (click)="buttonClick(element)">
                <mat-icon>read_more</mat-icon>
              </button>
            }
          </td>
        </ng-container>
      }
      <!-- Disclaimer column -->
      <ng-container matColumnDef="disclaimer">
        <td
          mat-footer-cell
          *matFooterCellDef
          colspan="2"
          style="font-size: 12px; font-style: italic; color: gray"
        >
          {{ footer() }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: columnsToDisplay"
        (click)="rowClick(row)"
        [class.selected]="row === selectedRow"
      ></tr>

      <tr
        mat-footer-row
        *matFooterRowDef="['disclaimer']"
        style="height: 18px"
      ></tr>
    </table>
  }
}
